'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/rp-react-svg-icon/~/react/react.js
// module id = 1874
// module chunks = 0